import script from "./OngoingPatientTable.vue?vue&type=script&setup=true&lang=js"
export * from "./OngoingPatientTable.vue?vue&type=script&setup=true&lang=js"

import "./OngoingPatientTable.vue?vue&type=style&index=0&id=f98203de&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f98203de"]])

export default __exports__